import {css, StyleSheet} from 'aphrodite';
import React, {useMemo} from 'react';

import Enzymes from 'molbio/enzymes/backbone/Enzymes';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import {MenuWidth} from 'ui-library/menus/MenuConstants';
import SearchableMenu from 'ui-library/menus/SearchableMenu';

interface EnzymeSelectorProps {
  enzymes: Enzymes;
  selectedEnzymeId: number | null;
  onSelect: (enzymeId: number) => void;
}

export default function EnzymeSelector({
  enzymes,
  selectedEnzymeId,
  onSelect,
}: EnzymeSelectorProps): JSX.Element {
  const optionDatas = useMemo(
    () =>
      enzymes.map((enzyme) => ({
        name: enzyme.name(),
        value: enzyme.id,
      })),
    [enzymes]
  );
  const selectedEnzyme = enzymes.find(({id}) => id === selectedEnzymeId);
  return (
    <div className={css(styles.wrapper)}>
      <SelectDropdown
        displayName={selectedEnzyme != null ? selectedEnzyme.name() : 'Enzyme'}
        menu={
          <SearchableMenu
            onSelect={onSelect}
            optionDatas={optionDatas}
            selectedValue={selectedEnzymeId}
            width={MenuWidth.FULL}
          />
        }
      />
    </div>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    // Align with the LHS of the other form group elements
    marginLeft: '13px',
    width: '100%',
  },
});
